export const toIsoString = (date: Date) => {
  return new Date(date).toISOString().split("T")[0];
};
